import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

const MADRID_TZ = 'Europe/Madrid';

/** Календарна дата в Мадриді як YYYYMMDD (як у Cloud Functions / архівації). */
export function getMadridDateKeyNow(now: number = Date.now()): number {
  const madrid = toZonedTime(new Date(now), MADRID_TZ);
  return Number(format(madrid, 'yyyyMMdd'));
}

/** Madrid `dateKey` for an instant (узгоджено з Cloud Functions). */
export function getMadridDateKeyFromTimestamp(ms: number): number {
  return Number(format(toZonedTime(new Date(ms), MADRID_TZ), 'yyyyMMdd'));
}

/** Madrid `dateKey` для значення з DatePicker (`null` → сьогодні в Мадриді). */
export function getMadridDateKeyFromPickerDate(d: Date | null, nowMs: number = Date.now()): number {
  if (!d) return getMadridDateKeyNow(nowMs);
  return Number(format(toZonedTime(d, MADRID_TZ), 'yyyyMMdd'));
}
